import { useTranslation } from 'react-i18next';

export const keyPrefix = 'departmentStreamGroupList';
export const useDepartmentStreamGroupListTranslation = () => useTranslation('widgets', { keyPrefix });
export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Группы источников',
  },
}) : {}) as Record<string, unknown>;
export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Source groups',
  },
}) : {}) as Record<string, unknown>;
export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Grupos de flujo',
  },
}) : {}) as Record<string, unknown>;
export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Grupos de fluxo',
  },
}) : {}) as Record<string, unknown>;
